<template>
  <template v-if="isCompact">
    <TwnBaseBtn
      v-if="supportContact"
      v-tooltip.right="'Support'"
      aria-label="Support"
      icon="help"
      severity="secondary"
      variant="text"
      @click="openSupport"
    />
    <TwnBaseBtn
      v-if="isExo"
      v-tooltip.right="'EXO fiscalisation'"
      aria-label="EXO fiscalisation"
      icon="receipt_long"
      severity="secondary"
      variant="text"
      @click="openExo"
    />
  </template>

  <template v-else>
    <TwnFocusSidebarLink
      v-if="supportContact"
      :is-action="true"
      variant="space"
      @click="openSupport"
    >
      <MaterialIcon
        class="text-surface-500"
        ligature="help"
        size="1rem"
      />
      <span>Support</span>
    </TwnFocusSidebarLink>
    <TwnFocusSidebarLink
      v-if="isExo"
      :is-action="true"
      variant="space"
      @click="openExo"
    >
      <MaterialIcon
        class="text-surface-500"
        ligature="receipt_long"
        size="1rem"
      />
      <span>EXO fiscalisation</span>
    </TwnFocusSidebarLink>
  </template>

  <!-- The page header held these two; here each row opens its panel beside itself. -->
  <TwnSupportContactIndicator
    ref="supportRef"
    :has-trigger="false"
  />
  <TwnExoStatusIndicator
    v-if="isExo"
    ref="exoRef"
    :has-trigger="false"
  />
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import type { TwnFocusSidebarTenantLinksProps } from '@/domains/admin-panel/components/molecules/menu/twn-focus-sidebar-tenant-links/TwnFocusSidebarTenantLinks.types'

import TwnBaseBtn from '@/components/atoms/buttons/twn-base-btn/TwnBaseBtn.vue'
import MaterialIcon from '@/components/atoms/icons/material-icon/MaterialIcon.vue'
import TwnFocusSidebarLink from '@/domains/admin-panel/components/molecules/menu/twn-focus-sidebar-link/TwnFocusSidebarLink.vue'
import TwnExoStatusIndicator from '@/domains/fiscal/components/molecules/twn-exo-status-indicator/TwnExoStatusIndicator.vue'
import { useTenantIsExo } from '@/domains/fiscal/composables/use-tenant-is-exo/useTenantIsExo'
import TwnSupportContactIndicator from '@/domains/tenant/components/molecules/twn-support-contact-indicator/TwnSupportContactIndicator.vue'
import { useSupportContact } from '@/domains/tenant/composables/use-support-contact/useSupportContact'

withDefaults(defineProps<TwnFocusSidebarTenantLinksProps>(), { isCompact: false })

const supportRef = useTemplateRef<InstanceType<typeof TwnSupportContactIndicator>>('supportRef')
const exoRef = useTemplateRef<InstanceType<typeof TwnExoStatusIndicator>>('exoRef')
const supportContact = useSupportContact()
const isExo = useTenantIsExo()

const openSupport = (event: MouseEvent) => supportRef.value?.open(event)
const openExo = (event: MouseEvent) => exoRef.value?.open(event)
</script>
